module.exports = __webpack_public_path__ + "static/google-sheets-animation-8938b5b479d2d94175a0e66a385f532e.mp4";